module.exports = __webpack_public_path__ + "static/img/newsbg.23473f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsbg.jpg
// module id = 5Fmp
// module chunks = 1